module.exports = __webpack_public_path__ + "static/media/download_appstore_en.8c4986ee.svg";